var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from "react";
import { required, } from "../../utils/validation";
var TeaxtareaField = function (props) {
    function isRequired(value) {
        return !props.required || (props.required && !!required(value));
    }
    function handleBlur(e) {
        setFocusClass("");
        var errorObj = {};
        if (props.required) {
            errorObj = __assign(__assign({}, errorObj), { required: isRequired(value) });
        }
        props.onBlur(errorObj, e);
    }
    var _a = __read(React.useState(""), 2), focusClass = _a[0], setFocusClass = _a[1];
    var _b = __read(React.useState(props.defaultValue || ""), 2), value = _b[0], setValue = _b[1];
    React.useEffect(function () {
        if (props.defaultValue !== undefined && value !== props.defaultValue) {
            setValue(props.defaultValue);
        }
    }, [props.defaultValue]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "col" },
            React.createElement("div", { className: props.className },
                React.createElement("div", { className: props.placeholderClassName +
                        (props.errorText ? " error" : focusClass) }, value === "" && props.label && (React.createElement(React.Fragment, null,
                    React.createElement("label", { htmlFor: props.id }, props.placeholder),
                    props.required && React.createElement("span", { className: "star" }, "*")))),
                React.createElement("textarea", { defaultValue: value, 
                    //  onChange={handleChange}
                    onChange: props.onChangeEvent, placeholder: props.label ? "" : props.placeholder, className: "form-control", id: props.id, name: props.name, required: props.required, onFocus: function () { return setFocusClass(" focus"); }, onBlur: function (e) { return handleBlur(e); } })))));
};
export default TeaxtareaField;
{ /* <div className="holder">
              <label htmlFor="poptextarea">Comments</label>{""}
              <span className="star">*</span>
          </div>
          <textarea className="form-control" rows={3}  name="cmmt" id="cmmt" onChange={(e) => handleChange(e)} ></textarea> */
}
